module.exports = __webpack_public_path__ + "img/icon_menu_search.1ef03609.svg";